import React from 'react';
import { Form, Input, Row, Col, Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import PATH from '@/config/paths/PATH';
import AppForm from '@/components/AppForm';
import { createTopic } from '@/services/topic.service';
import { useMutation } from '@tanstack/react-query';
import AppPageTitle from '@/components/AppPageTitle';
import useFormSubmit from '@/hooks/useFormSubmit';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

const TopicCreate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const topicMutation = useMutation({
    mutationFn: createTopic,
  });

  const handleOnSubmit = useFormSubmit(
    topicMutation,
    (values) => ({
      ...values,
      is_active: values.is_active ? 1 : 0,
    }),
    {
      onOk: () => {
        navigate(PATH.TOPIC.ROOT, {
          replace: true,
        });
      },
    }
  );

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <div>
      <AppPageTitle title="Create Topic" />
      <AppForm
        form={form}
        onSubmit={handleOnSubmit}
        targetPath={PATH.TOPIC.ROOT}
        buttonProps={{
          loading: topicMutation.isPending,
          disabled: topicMutation.isPending,
        }}
        disabled={topicMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Name English"
              name="name_en"
              rules={[{ required: true, message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
          </Col>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Name Myanmar"
              name="name_my"
              rules={[{ required: true, message: 'Please enter Myanmar name' }]}
            >
              <Input placeholder="Enter name myanmar" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="is_active" valuePropName="checked" label="Active">
          {/* <Checkbox >Active</Checkbox> */}
          <Switch title="Active" />
        </Form.Item>
      </AppForm>
    </div>
  );
};

export default TopicCreate;
